// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: Sidebar.js
// Description: This file is responsible to show Hamburger Menu Navigation
//
// ************************************************************************************************************************************************************
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "../../../App.css";
import * as Actions from "../redux/action";
import { getFacilityAllCount } from "../Facilities/_redux/facilityCrud";
import { getMonitersCount } from "../Monitors/_redux/monitorCrud";
import { getUsersCount } from "../Users/_redux/userCrud";
import history from "../../history";
import { withRouter } from "react-router";
import { Divider } from "@material-ui/core";
import { ReactComponent as MonitorImg } from "../../../icons/MonitorImg.svg";
import { ReactComponent as FacilitySvg } from "../../../icons/FacilitySvg.svg";
import { ReactComponent as Helpsvg } from "../../../icons/Helpsvg.svg";
import { ReactComponent as Arrowdown } from "../../../icons/Arrowdown.svg";
import { ReactComponent as User } from "../../../icons/menu_user.svg";
import { MenuType, MenuPath } from "../../../Application_Constants";

class NavigationPage extends React.Component {
  constructor(props) {
    super(props);
    this.handleExpandMonitor = this.handleExpandMonitor.bind(this);
    this.handleExpandUser = this.handleExpandUser.bind(this);
    this.state = {
      loading: false,
      errorMessage: null,
      responseMessage: null,
      facilityActiveIndex: "all",
      isEdit: false,
      editId: null,
      modalShow: false,
      expand: false,
      count: 15,
      page: 1,
      facilityCount: 0,
      expand1: false,
      paginationLoading: false,
      allMonitorCount: 0,
      unassignedMonitorCount: 0,
      assignedMonitorCount: 0,
      deletedMonitorCount: 0,
      userCount: 0,
      flength: 0,
      open: false,
      color: true,
      inactiveCount: 0,
      activeCount: 0,
      tabName: MenuType.MONITOR_ALL
    };
  }

  componentDidMount() {
    this.monitorsAllcount();
    this.monitorsAssignedcount();
    this.monitorsUnassignedcount();
    this.monitorsDeletedcount();
    this.usersMenucounts(MenuType.USER_ALL);
    this.usersMenucounts(MenuType.USER_ACTIVE);
    this.usersMenucounts(MenuType.USER_INACTIVE);
    this.facilitiesAllcount();
    // browser back button click function
    window.onpopstate = () => {
      let backStateTabName = this.state.tabName;
      switch (this.props.history.location.pathname) {
        case MenuPath.HELP:
          backStateTabName = MenuType.HELP;
          this.ChangeMenuSelection(MenuType.HELP);
          this.props.handleDelete(false);
          break;
        case MenuPath.FACILITY_ALL:
          backStateTabName = MenuType.FACILITY_ALL;
          this.ChangeMenuSelection(MenuType.FACILITY_ALL);
          this.props.handleDelete(false);
          break;
        case MenuPath.MONITOR_ALL:
          backStateTabName = MenuType.MONITOR_ALL;
          this.ChangeMenuSelection(MenuType.MONITOR_ALL);
          this.props.handleDelete(false);
          break;
        case MenuPath.MONITOR_ASSIGNED:
          backStateTabName = MenuType.MONITOR_ASSIGNED;
          this.ChangeMenuSelection(MenuType.MONITOR_ASSIGNED);
          this.props.handleDelete(false);
          break;
        case MenuPath.MONITOR_UNASSIGNED:
          backStateTabName = MenuType.MONITOR_UNASSIGNED;
          this.ChangeMenuSelection(MenuType.MONITOR_UNASSIGNED);
          this.props.handleDelete(false);
          break;
        case MenuPath.MONITOR_DELETED:
          backStateTabName = MenuType.MONITOR_DELETED;
          this.ChangeMenuSelection(MenuType.MONITOR_DELETED);
          this.props.handleDelete(false);
          break;
        case MenuPath.USER_ALL:
          backStateTabName = MenuType.USER_ALL;
          this.ChangeMenuSelection(MenuType.USER_ALL);
          this.props.handleDelete(false);
          break;
        case MenuPath.USER_INACTIVE:
          backStateTabName = MenuType.USER_INACTIVE;
          this.ChangeMenuSelection(MenuType.USER_INACTIVE);
          this.props.handleDelete(false);
          break;
        case MenuPath.USER_ACTIVE:
          backStateTabName = MenuType.USER_ACTIVE;
          this.ChangeMenuSelection(MenuType.USER_ACTIVE);
          this.props.handleDelete(false);
          break;
        default:
          backStateTabName = MenuType.MONITOR_ALL;
          this.ChangeMenuSelection(MenuType.MONITOR_ALL);
          this.props.handleDelete(false);
          history.push(MenuPath.MONITOR_ALL);
      }
      this.setState({
        ...this.state,
        tabName: backStateTabName
      });
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedMenu !== this.props.selectedMenu) {
      if (this.selectedMenu === "monitors") {
        history.push("/dashboard/monitors");
      }
      this.setState({
        ...this.state
      });
    }

    if (
      this.props.isRefreshMonitor !== prevProps.isRefreshMonitor &&
      this.props.isRefreshMonitor === true
    ) {
      this.props.refreshMonitorCount(false);
      this.monitorsAllcount();
      this.monitorsAssignedcount();
      this.monitorsUnassignedcount();
      this.monitorsDeletedcount();
    }
    if (
      this.props.isRefreshUser !== prevProps.isRefreshUser &&
      this.props.isRefreshUser === true
    ) {
      this.props.refreshUsercount(false);
      this.usersMenucounts(MenuType.USER_ALL);
      this.usersMenucounts(MenuType.USER_ACTIVE);
      this.usersMenucounts(MenuType.USER_INACTIVE);
    }
    if (
      this.props.isRefreshFacility !== prevProps.isRefreshFacility &&
      this.props.isRefreshFacility === true
    ) {
      this.props.refreshFacitityAcount(false);
      this.facilitiesAllcount();
    }
  }

  handleExpandMonitor() {
    if (this.state.expand) {
      this.setState({ expand: false });
    } else {
      this.setState({ expand: true });
    }
  }

  MenuSelection = (Menu) => {
    switch (Menu) {
      case MenuType.HELP:
        this.setState({
          tabName: MenuType.HELP
        });

        this.ChangeMenuSelection(MenuType.HELP);
        this.props.handleDelete(false);
        history.push(MenuPath.HELP);

        break;
      case MenuType.FACILITY_ALL:
        this.setState({
          tabName: MenuType.FACILITY_ALL
        });
        this.ChangeMenuSelection(MenuType.FACILITY_ALL);
        this.props.handleDelete(false);
        history.push(MenuPath.FACILITY_ALL);

        break;
      case MenuType.MONITOR_ALL:
        this.setState({
          tabName: MenuType.MONITOR_ALL
        });
        this.ChangeMenuSelection(MenuType.MONITOR_ALL);
        this.props.handleDelete(false);
        history.push(MenuPath.MONITOR_ALL);

        break;
      case MenuType.MONITOR_ASSIGNED:
        this.setState({
          tabName: MenuType.MONITOR_ASSIGNED
        });
        this.ChangeMenuSelection(MenuType.MONITOR_ASSIGNED);
        this.props.handleDelete(false);
        history.push(MenuPath.MONITOR_ASSIGNED);

        break;
      case MenuType.MONITOR_UNASSIGNED:
        this.setState({
          tabName: MenuType.MONITOR_UNASSIGNED
        });
        this.ChangeMenuSelection(MenuType.MONITOR_UNASSIGNED);
        this.props.handleDelete(false);
        history.push(MenuPath.MONITOR_UNASSIGNED);

        break;
      case MenuType.MONITOR_DELETED:
        this.setState({
          tabName: MenuType.MONITOR_DELETED
        });
        this.ChangeMenuSelection(MenuType.MONITOR_DELETED);
        this.props.handleDelete(false);
        history.push(MenuPath.MONITOR_DELETED);

        break;
      case MenuType.USER_ALL:
        this.setState({
          tabName: MenuType.USER_ALL
        });
        this.ChangeMenuSelection(MenuType.USER_ALL);
        this.props.handleDelete(false);
        history.push(MenuPath.USER_ALL);

        break;
      case MenuType.USER_INACTIVE:
        this.setState({
          tabName: MenuType.USER_INACTIVE
        });
        this.ChangeMenuSelection(MenuType.USER_INACTIVE);
        this.props.handleDelete(false);
        history.push(MenuPath.USER_INACTIVE);
        break;
      case MenuType.USER_ACTIVE:
        this.setState({
          tabName: MenuType.USER_ACTIVE
        });
        this.ChangeMenuSelection(MenuType.USER_ACTIVE);
        this.props.handleDelete(false);
        history.push(MenuPath.USER_ACTIVE);
        break;
      default:
    }
  };
  ChangeMenuSelection = (menuType) => {
    if (this.props.selectedMenu !== menuType) {
      this.props.changeMenu(menuType);
    }
  };

  handleExpandUser() {
    if (this.state.openTwo) {
      this.setState({ openTwo: false });
    } else {
      this.setState({ openTwo: true });
    }
  }

  /*
==================================================================================
Created On : 25/10/2023
Purpose: To Fetch  all Monitors count
==================================================================================
*/
  monitorsAllcount() {
    getMonitersCount(MenuType.MONITOR_ALL)
      .then((res) => {
        const { count } = res.data;
        this.setState({
          ...this.state,
          allMonitorCount: count
        });
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          errorMessage: error.message,
          responseMessage: true
        });
      });
  }
  /*
==================================================================================
Created On : 25/10/2023
Purpose: To Fetch  assigned Monitors count
==================================================================================
*/

  monitorsAssignedcount() {
    getMonitersCount(MenuType.MONITOR_ASSIGNED)
      .then((res) => {
        const { status, count } = res.data;
        if (status === true) {
          this.setState({
            ...this.state,
            assignedMonitorCount: count
          });
        }
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          errorMessage: error.message,
          responseMessage: true
        });
      });
  }
  /*
==================================================================================
Created On : 25/10/2023
Purpose: To Fetch  unassigned Monitors count
==================================================================================
*/

  monitorsUnassignedcount() {
    getMonitersCount(MenuType.MONITOR_UNASSIGNED)
      .then((res) => {
        const { status, count } = res.data;
        if (status === true) {
          this.setState({
            ...this.state,
            unassignedMonitorCount: count
          });
        }
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          errorMessage: error.message,
          responseMessage: true
        });
      });
  }
  /*
==================================================================================
Created On : 25/10/2023
Purpose: To Fetch  deleted Monitors count
==================================================================================
*/
  monitorsDeletedcount() {
    getMonitersCount(MenuType.MONITOR_DELETED)
      .then((res) => {
        const { status, count } = res.data;
        if (status === true) {
          this.setState({
            ...this.state,
            deletedMonitorCount: count
          });
        }
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          errorMessage: error.message,
          responseMessage: true
        });
      });
  }
  /*
==================================================================================
Created On : 25/10/2023
Purpose: To Fetch Users Count based on Menu Type. 
==================================================================================
*/
  usersMenucounts(Menu) {
    getUsersCount(Menu)
      .then((res) => {
        const { count } = res.data;
        switch (Menu) {
          case MenuType.USER_ALL:
            this.setState({
              ...this.state,
              userCount: count
            });

            break;
          case MenuType.USER_ACTIVE:
            this.setState({
              ...this.state,
              activeCount: count
            });
            break;
          case MenuType.USER_INACTIVE:
            this.setState({
              ...this.state,
              inactiveCount: count
            });
            break;
            default:
        }
      })

      .catch((error) => {
        this.setState({
          ...this.state,
          errorMessage: error.message,
          responseMessage: true
        });
      });
  }

  /*
==================================================================================
Created On : 25/10/2023
Purpose: To Fetch  all Facilities count
==================================================================================
*/
  facilitiesAllcount() {
    getFacilityAllCount()
      .then((res) => {
        const { count } = res.data;
        this.setState({
          ...this.state,
          facilityCount: count
        });
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          errorMessage: error.message,
          responseMessage: true
        });
      });
  }

  render() {
    return (
      <div>
        <Divider style={{ marginTop: "32%" }}></Divider>
        <div className="main">
          <div className="sidebar">
            <div className="sidebar-item">
              <div className="sidebar-tittle">
                {!this.state.expand && (
                  <Arrowdown
                    style={{ transform: "rotate(-90deg)" }}
                    onClick={this.handleExpandMonitor}
                    className="arrow"
                  />
                )}

                {this.state.expand && (
                  <Arrowdown
                    onClick={this.handleExpandMonitor}
                    className="arrowdown"
                  />
                )}
                <span onClick={this.handleExpandMonitor}>Monitors</span>

                <MonitorImg className="sidebarImg" />
              </div>
            </div>

            {this.state.expand && (
              <div>
                <div
                  className={
                    this.state.tabName === MenuType.MONITOR_ALL
                      ? "sidebar-active"
                      : "sidebar"
                  }
                  onClick={() => this.MenuSelection(MenuType.MONITOR_ALL)}
                >
                  <div className="sidebar-item">
                    <div className="sidebar-content">
                      <MonitorImg className="teal" />
                      <span>All</span>
                      <div className="head">{this.state.allMonitorCount}</div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    this.state.tabName === MenuType.MONITOR_ASSIGNED
                      ? "sidebar-active"
                      : "sidebar"
                  }
                  onClick={() => this.MenuSelection(MenuType.MONITOR_ASSIGNED)}
                >
                  <div className="sidebar-item">
                    <div className="sidebar-content">
                      <MonitorImg className="teal" />
                      <span>Assigned</span>
                      <div className="head">
                        {this.state.assignedMonitorCount}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    this.state.tabName === MenuType.MONITOR_UNASSIGNED
                      ? "sidebar-active"
                      : "sidebar"
                  }
                  onClick={() =>
                    this.MenuSelection(MenuType.MONITOR_UNASSIGNED)
                  }
                >
                  <div className="sidebar-item">
                    <div className="sidebar-content">
                      <MonitorImg className="teal" />
                      <span>Unassigned</span>
                      <div className="head">
                        {this.state.unassignedMonitorCount}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={
                    this.state.tabName === MenuType.MONITOR_DELETED
                      ? "sidebar-active"
                      : "sidebar"
                  }
                  onClick={() => this.MenuSelection(MenuType.MONITOR_DELETED)}
                >
                  <div className="sidebar-item">
                    <div className="sidebar-content">
                      <MonitorImg className="teal" />
                      <span> Deleted</span>
                      <div className="head">
                        {this.state.deletedMonitorCount}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div
              onClick={() => this.MenuSelection(MenuType.FACILITY_ALL)}
              className={
                this.state.tabName === MenuType.FACILITY_ALL
                  ? "sidebar-active"
                  : "sidebar"
              }
            >
              <div className="sidebar-item-facilities">
                <div className="sidebar-tittle">
                  <span> All Facilities</span>

                  <FacilitySvg className="teal" />

                  <div className="head-facilities">
                    {this.state.facilityCount}
                  </div>
                </div>
              </div>
            </div>

            <div className="sidebar">
              <div className="sidebar-item">
                <div className="sidebar-tittle">
                  {!this.state.openTwo && (
                    <Arrowdown
                      style={{ transform: "rotate(-90deg)" }}
                      onClick={this.handleExpandUser}
                      className="arrow"
                    />
                  )}

                  {this.state.openTwo && (
                    <Arrowdown
                      onClick={this.handleExpandUser}
                      className="arrowdown"
                    />
                  )}
                  <span onClick={this.handleExpandUser}>Users</span>
                  <div>
                    <User className="teal sidebarImg" />
                  </div>
                </div>
              </div>
            </div>
            {this.state.openTwo && (
              <div>
                <div
                  onClick={() => this.MenuSelection(MenuType.USER_ALL)}
                  className={
                    this.state.tabName === MenuType.USER_ALL
                      ? "sidebar-active"
                      : "sidebar"
                  }
                >
                  <div className="sidebar-item">
                    <div
                      onClick={() => this.MenuSelection(MenuType.USER_ALL)}
                      className="sidebar-content"
                    >
                      <User className="teal" />
                      <span>All</span>
                      <div className="head">{this.state.userCount}</div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    this.state.tabName === MenuType.USER_ACTIVE
                      ? "sidebar-active"
                      : "sidebar"
                  }
                  onClick={() => this.MenuSelection(MenuType.USER_ACTIVE)}
                >
                  <div className="sidebar-item">
                    <div className="sidebar-content">
                      <User className="teal" />

                      <span>Active</span>
                      <div className="head">{this.state.activeCount}</div>
                    </div>
                  </div>
                </div>
                <div
                  className={
                    this.state.tabName === MenuType.USER_INACTIVE
                      ? "sidebar-active"
                      : "sidebar"
                  }
                  onClick={() => this.MenuSelection(MenuType.USER_INACTIVE)}
                >
                  <div className="sidebar-item">
                    <div className="sidebar-content">
                      <User className="teal" />

                      <span>Inactive</span>
                      <div className="head">{this.state.inactiveCount}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div
              className={
                this.state.tabName === MenuType.HELP
                  ? "sidebar-active"
                  : "sidebar"
              }
              onClick={() => this.MenuSelection(MenuType.HELP)}
            >
              <div className="sidebar-item">
                <div className="sidebar-tittle">
                  <Helpsvg
                    className="teal"
                    style={{ marginLeft: "5px" }}
                  ></Helpsvg>
                  <span className="sidebar-help">Help</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeMenu: Actions.changeSideBar,
      FacilityName: Actions.FacilityName,
      refreshMonitorCount: Actions.refreshMonitorCount,
      refreshUsercount: Actions.refreshUsercount,
      refreshFacitityAcount: Actions.refreshFacitityAcount,
      handleDelete: Actions.handleDelete
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    selectedMenu: state.selectedMenu,
    addFacility: state.addFacility,
    facilityName: state.facilityName,
    isRefreshMonitor: state.isRefreshMonitor,
    isRefreshUser: state.isRefreshUser,
    isRefreshFacility: state.isRefreshFacility
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NavigationPage)
);
